// ABOUTME: The No Storm content code and the copy that depends on it, kept in one place so the designed copy is a small change.
// ABOUTME: The 2C line and the 3A strings are what the child reads when the pick was No Storm.

export const NO_STORM = 'no_storm';

export const NO_STORM_REVEAL_TEXT = 'It was just weather — big feelings, and no Storm underneath.';

export const NO_STORM_3A_HEADLINE = 'Even big weather can reach past us and touch what matters.';
export const NO_STORM_3A_SUB = 'Tap what it reached this time — one or more. Tap again to remove.';
